import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import { Typography } from '@/components/ui/typography'

import * as S from './survey-details-charts.styled'
import { SurveyDetailsChartsProps } from './survey-details-charts.types'
import { getChartData, getChartOptions, getTotalResponses } from './survey-details-charts.utils'

export const SurveyDetailsCharts = ({ questions, subtype }: SurveyDetailsChartsProps) => {
  const { t } = useTranslation(['communication'])
  const isSingle = questions.length === 1

  return (
    <S.Container>
      <S.Header>
        <Typography color="black800" size="text-large" weight="medium">
          {t('communication:surveyDetails.charts.title')}
        </Typography>
      </S.Header>
      <S.ChartsGrid>
        {questions.map((question) => {
          const totalResponses = getTotalResponses(question.responses ?? [])
          const chartData = getChartData(question, subtype, t)
          const chartOptions = getChartOptions(totalResponses)

          return (
            <S.ChartItem key={question.id} $isSingle={isSingle}>
              <Typography color="black800" size="text-large" weight="medium">
                {question.title}
              </Typography>
              <S.ChartRow>
                <S.ChartWrapper>
                  <Doughnut data={chartData} options={chartOptions} />
                  <S.CenterLabel>
                    <S.TotalResponsesValue color="black800" weight="medium">
                      {totalResponses}
                    </S.TotalResponsesValue>
                    <Typography color="black800" size="text-large">
                      {t('communication:surveyDetails.charts.totalResponses')}
                    </Typography>
                  </S.CenterLabel>
                </S.ChartWrapper>
                <S.Legend>
                  {chartData.labels.map((label, index) => (
                    <S.LegendItem key={label}>
                      <S.LegendDot $color={chartData.datasets[0].backgroundColor[index]} />
                      <Typography color="black800" size="text-small">
                        {label}
                      </Typography>
                    </S.LegendItem>
                  ))}
                </S.Legend>
              </S.ChartRow>
            </S.ChartItem>
          )
        })}
      </S.ChartsGrid>
    </S.Container>
  )
}
